// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".childBoxSelected{background-color:#fff6ec}", "",{"version":3,"sources":["webpack://./_editor/components/canvas/plugin_placeholder/_pluginPlaceHolder.scss","webpack://./sass/general/_variables.scss"],"names":[],"mappings":"AAEA,kBACE,wBCYa","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
